export const ABOUT_DETAIL_FETCH = 'ABOUT_DETAIL_FETCH';
export const ABOUT_DETAIL_SUCCESS = 'ABOUT_DETAIL_SUCCESS';
export const ABOUT_DETAIL_FAILURE = 'ABOUT_DETAIL_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/AboutDetail/actionTypes.js